<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span *ngIf="addOrUpdateProductOptions.service.ServiceId === undefined">{{ 'Insert' | translate }}
        : {{ 'Service' | translate }}</span>
      <span *ngIf="addOrUpdateProductOptions.service.ServiceId !== undefined">{{ 'Update' | translate }}
        : {{ 'Service' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0">
  <div class="row my-4 pb-1 ">
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="title"
                          [required]="true"
                          [title]="'Title'"></app-frontend-input>
    </div>
    <div [ngClass]="servicePrice ? 'd-flex gap-3': ''"
         class="col-md-6 col-12">
      @if (servicePrice) {
        <app-frontend-check-box [(value)]="isChangeCapacity"
                                [title]="'IsChangeCapacity'"></app-frontend-check-box>
      }
      <app-frontend-input [(value)]="maxCapacity"
                          [disabled]="!isChangeCapacity"
                          [required]="true"
                          [title]="servicePrice ? 'RemainedCapacity' : 'MaxCapacity'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="uniqueIdentifier"
                          [required]="true"
                          [title]="'UniqueIdentifier'"
                          [type]="'text'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="priority"
                          [required]="true"
                          [title]="'Priority'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="price"
                          [required]="true"
                          [title]="'Price'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="newPrice"
                          [required]="false"
                          [title]="'NewPrice'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-date [(value)]="startTime"
                         [required]="true"
                         [title]="'StartTimeToServe'"
                         [type]="'time'"
                         [visibleTimePicker]="false"></app-frontend-date>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-date [(value)]="endTime"
                         [required]="true"
                         [title]="'EndTimeToServe'"
                         [type]="'time'"
                         [visibleTimePicker]="false"></app-frontend-date>
    </div>
    <div class="col-md-10 col-12">
      <app-frontend-text-area [(value)]="description"
                              [required]="false"
                              [title]="'Description'"></app-frontend-text-area>
    </div>
    <div class="col-md-2 col-12">
      <app-frontend-check-box [(value)]="isActive"
                              [title]="'IsActive'"></app-frontend-check-box>
    </div>
    <div class="col-12">
      <app-frontend-file-chooser [(files)]="imageFiles"
                                 [accept]="'png'"
                                 [isMultiple]="true"
                                 [title]="'Images'"></app-frontend-file-chooser>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (onSubmit)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'icons/tick-square.svg'"
                           [title]="'Submit'"
                           [validationRequired]="true">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
